module.exports = __webpack_public_path__ + "static/media/biblio_riley.59de95de.pdf";